import { LayoutViewType } from 'src/enums/user.enum';

export type LoginLayoutPropsType = {
  // children: React.ReactNode;
};

export const getLoginImages = (layout: LayoutViewType): { background: string; logo: string } => {
  switch (layout) {
    case LayoutViewType.SC3_LAYOUT:
      return {
        background: '/loginTemplate/login_bg.jpg',
        logo: '/loginTemplate/company_logo_new.svg',
      };

    default:
      return {
        background: '/loginBackground.png',
        logo: '/nginr_LOGO_dikey_negatif.png',
      };
  }
};
